import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppSidebarModule } from '../sidebar';
import { SidebarToggleDirective } from '../directives/layout.directive';
 
import { AppHeaderComponent } from './app-header.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule, 
    AppSidebarModule
  ],
  exports: [
    AppHeaderComponent, 
  ],
  declarations: [
    AppHeaderComponent,
    SidebarToggleDirective
  ]
})
export class AppHeaderModule {}
